import { themeBackgrounds, themeColors } from "@dana/MobiusOverrides/styles/colors";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { productDetailsImageCarouselStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsImageCarousel";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { IconWrapper } from "@insite/mobius/Icon";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

productDetailsImageCarouselStyles.imageCarousel = mergeToNew(productDetailsImageCarouselStyles.imageCarousel, {
    carouselSlideInner: {
        css: css`
            padding: 8px 4px 0;
            height: 100%;
        `,
    },
    image: {
        css: css`
            border: none;
            max-width: 48px;
            max-height: 48px;

            img {
                max-width: 48px;
                max-height: 48px;
                object-fit: contain;
            }
        `,
    },
    selectedImage: {
        css: css`
            border: 1px solid ${themeColors.primary.danaBlue};
            max-width: 48px;
            max-height: 48px;

            img {
                max-width: 48px;
                max-height: 48px;
            }
        `,
    },
    prevArrowButton: {
        css: css`
            border: none;
            background: transparent;
            min-height: auto;

            ${IconWrapper} {
                &,
                & svg {
                    width: 24px;
                    height: 48px;
                }

                svg {
                    path {
                        fill: ${themeColors.primary.danaBlue};
                    }
                }
            }

            &:not(:disabled):hover {
                background: transparent;
                border: none;
                color: ${themeColors.primary.danaBlue};

                svg {
                    path {
                        fill: ${themeColors.secondary.danaDarkBlue};
                    }
                }
            }

            &:disabled {
                background: transparent;
                border: none;

                ${IconWrapper} {
                    svg {
                        path {
                            fill: ${themeBackgrounds.darkGray};
                        }
                    }
                }
            }
        `,
    },
    nextArrowButton: {
        css: css`
            border: none;
            background: transparent;
            min-height: auto;

            &:not(:disabled):hover {
                background: transparent;
                border: none;
                color: ${themeColors.primary.danaBlue};

                svg {
                    path {
                        fill: ${themeColors.secondary.danaDarkBlue};
                    }
                }
            }

            ${IconWrapper} {
                &,
                & svg {
                    width: 24px;
                    height: 48px;
                }

                svg {
                    path {
                        fill: ${themeColors.primary.danaBlue};
                    }
                }
            }

            &:disabled {
                background: transparent;
                border: none;

                ${IconWrapper} {
                    svg {
                        path {
                            fill: ${themeBackgrounds.darkGray};
                        }
                    }
                }
            }
        `,
    },
    videoModal: {
        sizeVariant: "large",
        cssOverrides: {
            modalBody: css`
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                height: 60dvh;
                            `,
                            css`
                                height: 60dvh;
                            `,
                            css`
                                min-height: 60dvh;
                                height: -webkit-fill-available;
                            `,
                            css`
                                min-height: 60dvh;
                                height: -webkit-fill-available;
                            `,
                            css`
                                min-height: 60dvh;
                                height: -webkit-fill-available;
                                max-height: 60dvh;
                            `
                        ],
                        "min",
                    )}
            `,
            modalTitle: css`
                border: none;
            `,
            modalContent: css`
                height: 100%;
            `,
        },
    },
});
